const COMPONENT_NAME = "slideshow";
const CLASS_SELECTOR = ".Slideshow";
const CHILD_SELECTOR = ".SlideshowSlide";
const ACTIVE_FLAG = "is-active";

let nextIndex = 0;

const instances = [];
const handlers = {};

function initialize(element, PageComponents) {
    const children = element.querySelectorAll(CHILD_SELECTOR);
    const setSlide = (index) => {
        index = parseInt(index);
        if (children.length < 1) return;
        if (index < 0) index = children.length - 1;
        if (index >= children.length) index = 0;
        for (let i = 0; i < children.length; i ++) {
            children[i].classList.toggle(ACTIVE_FLAG, i === index);
        }
    };

    instances.push(element);

    handlers[element.getAttribute("id") || nextIndex++] = {
        element,
        children,
        setSlide
    };

    if (!PageComponents.Slideshow) PageComponents.Slideshow = Slideshow;
}

const Slideshow = {
    name: COMPONENT_NAME,
    instances,
    handlers,
    initialize,
};

module.exports = Slideshow;
